import { useEffect } from "react";
import lottie from "lottie-web";

export default function BottomPopOverModal({
    dataFoRpopup,
    popUpMsg,
    searchAnimation,
    showPopOver,
    setShowPopOver,
    checkAndNavigate,
    loanAmount = 0, // 👈 passed from parent
    yesBtnText = "",
    noBtnText = "",
    noBtnClick = () => { }
}) {

    useEffect(() => {
        if (!!searchAnimation) {
            lottie.loadAnimation({
                container: document.querySelector("#searchAnimation"),
                animationData: searchAnimation,
                renderer: "canvas"
            });
        }
    }, []);

    const treatmentAmount = parseFloat(loanAmount || 0);
    const totalEmi = parseInt(dataFoRpopup?.totalEmi || 1);
    const advanceEmi = parseInt(dataFoRpopup?.advanceEmi || 0);
    const emiAmount = treatmentAmount / totalEmi;
    const advanceAmount = emiAmount * advanceEmi;
    const noCostPayment = treatmentAmount - advanceAmount;

    return (
        <div
            className={'bottomPopOverModal ' + (showPopOver ? "open" : "")}
            onClick={() => setShowPopOver(false)}
            style={{
                height: "100%",
                width: "100%",
                background: "rgba(0,0,0,0.2)",
                position: "absolute",
                top: "0",
                left: "0",
                zIndex: 5,
                display: "flex",
                alignItems: "center",
                padding: "0"
            }}
        >
            <div
                className="popUpCard-custom"
                style={{
                    width: "100%",
                    background: "white",
                    boxShadow: "0px 0px 10px #ccc",
                    borderRadius: "8px 8px 0px 0px",
                    padding: "10px",
                    paddingBottom: "48px",
                    position: "absolute",
                    margin: "0"
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div style={{ marginBottom: '10px', fontWeight: 'bold', textAlign: 'left' }}>
                    Confirm advance payment?
                </div>

                <div style={{
                    padding: "0px 24px",
                    marginBottom: "0px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <div style={{
                        border: '1px solid #e6e6e6',
                        borderRadius: '12px',
                        padding: '16px',
                        width: '100%',
                        maxWidth: '400px'
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                            <div>Treatment amount</div>
                            <div>₹{treatmentAmount.toLocaleString('en-IN')}</div>
                        </div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginBottom: '12px',
                            padding: '8px 0px',
                            borderRadius: '8px',
                            backgroundColor: '#ecfdf5',
                            fontWeight: 600
                        }}>
                            <div>Advance payment</div>
                            <div>₹{advanceAmount.toLocaleString('en-IN', { maximumFractionDigits: 0 })}</div>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                            <div>No-cost payment</div>
                            <div>₹{noCostPayment.toLocaleString('en-IN', { maximumFractionDigits: 0 })}</div>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>EMI amount</div>
                            <div>₹{emiAmount.toLocaleString('en-IN', { maximumFractionDigits: 0 })}</div>
                        </div>
                    </div>
                </div>

                <button
                    className='submit'
                    onClick={checkAndNavigate}
                >
                    {yesBtnText !== "" ? yesBtnText : "Confirm"}
                </button>
            </div>
        </div>
    );
}
